import { prepHandleEvent } from "./prepHandleEvent";

export function handlePaste(canvas) {
  return function (event) {
    if (document.activeElement !== canvas) {
      return;
    }
    var myApp = prepHandleEvent(this, false, null, null);
    if (myApp == null) return;

    var clipboardData = event.clipboardData || window.clipboardData;
    var pastedData = clipboardData.getData("Text");

    myApp.HandlePaste(pastedData);
  };
}
